module.exports = __webpack_public_path__ + "static/media/news-fr.c48f7084.webp";